import React from 'react';
import { store } from './store';
import { Provider } from 'react-redux';
import ScreenRouter from './screen-router';
import { AudioManager } from './controllers/audioController';
import { allAudio } from './helpers/audio';

function App() {
    AudioManager.add(allAudio);

    return (
        <Provider store={store}>
            <ScreenRouter />
        </Provider>
    );
}

export default App;
